// Класовете на полетата и плочките във формата „Нова резервация".

/** Поле за писане: 16px на тесен екран (иначе iOS зуумва при фокус). */
export const fieldClass = (isNarrow: boolean, invalid = false) =>
  `w-full rounded-[10px] border bg-surface px-3.5 font-medium text-ink outline-none transition-colors duration-150 placeholder:text-faint focus:border-brand ${
    invalid ? "border-danger" : "border-shade-3"
  } ${isNarrow ? "text-[16px]" : "text-[14px]"}`;

/**
 * Мястото вдясно в полето „Телефон" за чипа на познатия телефон
 * (`GuestHistoryChip`) — номерът не минава под него. На тесен екран (полето е
 * с 16px шрифт) чипът е сбит („◷ 5 ⌄") и иска по-малко място.
 */
export const guestHistoryChipRoom = (isNarrow: boolean) => (isNarrow ? "pr-[96px]" : "pr-[160px]");

/**
 * Плочка в решетката (ден/час/минута): избрана, избрана но вече минала
 * (зачертана, червен контур — „Създай" е спрян), минала или обикновена.
 */
export const tileClass = (active: boolean, disabled: boolean) => {
  const base =
    "flex cursor-pointer items-center justify-center rounded-[9px] border text-[13.5px] font-bold tabular-nums transition-colors duration-150 disabled:cursor-not-allowed";
  if (active && disabled) return `${base} border-danger bg-danger-tint text-danger-ink line-through`;
  if (active) return `${base} border-brand bg-brand-tint text-brand-deep-ink`;
  if (disabled) return `${base} border-shade-2 bg-transparent text-ghost`;
  return `${base} border-shade-3 bg-surface text-ink hover:border-shade-4 hover:bg-fill`;
};
